module.exports = __webpack_public_path__ + "img/bluesky3100_06.7fbbbf2f.jpg";